export default __webpack_public_path__ + "static/media/04d_folded.8182127e.png";